import { render, staticRenderFns } from "./LoadingButtonIcon.vue?vue&type=template&id=34c5ede6&scoped=true&"
import script from "./LoadingButtonIcon.vue?vue&type=script&lang=js&"
export * from "./LoadingButtonIcon.vue?vue&type=script&lang=js&"
import style0 from "./LoadingButtonIcon.vue?vue&type=style&index=0&id=34c5ede6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34c5ede6",
  null
  
)

export default component.exports